import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { EventTrackerInterface } from '@commons/tracker/event-tracker/event-tracker.interface';
import { WizFile } from '@wizbii/models';

@Component({
  selector: 'app-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileInputComponent),
      multi: true,
    },
  ],
})
export class FileInputComponent implements OnInit, ControlValueAccessor {
  private static COUNT = 0;

  id: string;

  onChange: (_: WizFile) => void;
  onTouched: () => void;

  model: WizFile;
  disabled: boolean;

  @Input() openFilePickerEvent: EventTrackerInterface;

  @Output() openFileInput = new EventEmitter<void>();
  @Output() choseFile = new EventEmitter<void>();

  ngOnInit(): void {
    FileInputComponent.COUNT++;
    this.id = `file-input-${FileInputComponent.COUNT}`;
  }

  doChange(target: any): void {
    const file = target.files.item(0);
    const wizFile = new WizFile();
    wizFile.domFile = file;
    wizFile.name = file.name;
    this.choseFile.emit();
    this.onChange(wizFile);
  }

  registerOnChange(fn: (_: WizFile) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

  writeValue(value: WizFile): void {
    this.model = value;
  }
}
